import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import useCustom from "../customHook/customHook";
import ReCAPTCHA from "react-google-recaptcha";

const constants = require("file-configs/constants");

export default function Captcha(props) {
  const [globalState, setGlobalState] = useCustom();

  useEffect(() => {}, []);

  const onChangeCaptcha = (value) => {
    // console.log("Captcha value:", value);
    setGlobalState({ verifiedCaptcha: true });
  };

  return (
    <section id="captcha">
      <div className="d-flex justify-content-center mt-4">
        <ReCAPTCHA
          //sitekey="6LcWqpIjAAAAAMkI5c3KV5sss6PUi3_teI9rHzRv"
          sitekey="6Le9R7cjAAAAAKX9-_tTxlceRa8RRAFfNhZlEYBs"
          onChange={onChangeCaptcha}
        />
        ,
      </div>
    </section>
  );
}
